export default __webpack_public_path__ + "static/media/directionArrows.b44e44ee.png";